import zapierApi from '@/infrastructure/api/zapier'
import { useState } from 'react'
import { PbUser } from '@itsrever/rever-api'
import { useAppSelector } from '@/redux/hooks'
import { useStoreGroups } from '@/hooks/use-store-groups'
import {
  StoreGroup,
  findGroupByKey,
  seesEveryGroup
} from '@/domain/store-group'

interface SendProductRequestParams {
  email: string
  featureText: string
  source: 'store' | 'product-request'
}

// The navbar's scope, never the first store whose settings the group view happens to load.
export const toProductRequestScope = (
  user: PbUser | undefined,
  groups: StoreGroup[],
  selectedEcommerce: string | undefined,
  selectedGroup: string | undefined
) => {
  if (selectedEcommerce) return selectedEcommerce
  const groupId = findGroupByKey(groups, selectedGroup)?.id
  if (groupId) return groupId
  if (user?.group && !seesEveryGroup(user)) return user.group
  return ''
}

export function useSendProductRequest() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const user = useAppSelector((s) => s.userApi.getMe.response.user)
  const selectedEcommerce = useAppSelector(
    (s) => s.generalData.selectedEcommerce
  )
  const selectedGroup = useAppSelector((s) => s.generalData.selectedGroup)
  const groups = useStoreGroups()

  async function sendProductRequest(params: SendProductRequestParams) {
    setIsLoading(true)
    setError(false)
    setSuccess(false)
    try {
      await zapierApi.sendProductRequest(
        params.email,
        toProductRequestScope(user, groups, selectedEcommerce, selectedGroup),
        params.featureText,
        params.source
      )
      setSuccess(true)
    } catch (err) {
      console.warn(err)
      setError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return { sendProductRequest, isLoading, error, success }
}
